import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from 'redux-persist/integration/react';
import App from './components/app/App';
import configureStore from "./store/configure.store";

import './css/styles.css';
import registerServiceWorker from './registerServiceWorker';

const configuredStore = configureStore();

const app = (
  <Provider store={configuredStore.store}>
    <PersistGate loading={null} persistor={configuredStore.persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider >
);

ReactDOM.render(app, document.getElementById("root") as HTMLElement);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx